<template>
  <div dir="rtl">
    <!-- ---tpb -->

    <!-- <div style="width: 165px !important" dir="ltr" class="mlogo t-alignlogo">
      <img class="wlogo" :src="pathLogo" />
    </div> -->

    <!-- ---nanosoft -->

    <div style="width: 120px !important" dir="ltr" class="mlogo t-alignlogo">
      <img class="wlogo" :src="pathLogo" />
    </div>

    <!-- ---esdf -->
    <!-- <div dir="ltr" class="mlogo t-alignlogo">
      <img class="wlogo" :src="pathLogo" />
    </div> -->

    <!-- ---raba // lcma -->

    <!-- null -->

    <div :class="{ 'mt-shortName': (alldata.shortName = null) }"></div>
    <h3 style="font-size: 30px" class="text-center">{{ alldata.fullName }}</h3>
    <h3 style="font-size: 20px" class="text-center">{{ alldata.shortName }}</h3>
    <h3 class="text-center">كشف الحضور والإنصراف</h3>
    <div>
      <h3 style="font-size: 20px" class="text-center">
        من <span style="margin-left;: 10px">{{ convert(date) }}</span> الى<span
          style="margin-right: 10px"
          >{{ convert(DateTo) }}</span
        >
      </h3>
    </div>
    <h3 v-if="Department != ''" style="font-size: 20px" class="text-center">
      التابع لـ {{ alldata.items[0].departmentName }}
    </h3>
    <h3 v-else style="font-size: 20px; height: 28px" class="text-center"></h3>

    <div style="margin-top: 50px" class="container body">
      <div>ر.م</div>
      <div>الموظف</div>
      <div>رقم الموظف</div>
      <div>مجموع الغياب</div>
      <div v-for="(item, id) in items[0].details" :key="id">
        {{ day_n(item.date) + "-" + convertDayString(item.dayString) }}
      </div>
      <!-- <div  v-if="day3(date, 1) != false ">{{ 1 + day2(date, 1) }} </div> -->
      <!-- <div v-if="day3(date, 2) != false ">{{ 2 + day2(date, 2) }}</div>
            <div v-if="day3(date, 3) != false ">{{ 3 + day2(date, 3) }}</div>
            <div v-if="day3(date, 4) != false ">{{ 4 + day2(date, 4) }}</div>
            <div v-if="day3(date, 5) != false ">{{ 5 + day2(date, 5) }}</div>
            <div v-if="day3(date, 6) != false ">{{ 6 + day2(date, 6) }}</div>
            <div v-if="day3(date, 7) != false ">{{ 7 + day2(date, 7) }}</div>
            <div v-if="day3(date, 8) != false ">{{ 8 + day2(date, 8) }}</div>
            <div v-if="day3(date, 9) != false ">{{ 9 + day2(date, 9) }}</div>
            <div v-if="day3(date, 10) != false ">{{ 10 + day2(date, 10) }}</div>
            <div v-if="day3(date, 11) != false ">{{ 11 + day2(date, 11) }}</div>
            <div v-if="day3(date, 12) != false ">{{ 12 + day2(date, 12) }}</div>
            <div v-if="day3(date, 13) != false ">{{ 13 + day2(date, 13) }}</div>
            <div v-if="day3(date, 14) != false ">{{ 14 + day2(date, 14) }}</div>
            <div v-if="day3(date, 15) != false ">{{ 15 + day2(date, 15) }}</div>
            <div v-if="day3(date, 16) != false ">{{ 16 + day2(date, 16) }}</div>
            <div v-if="day3(date, 17) != false ">{{ 17 + day2(date, 17) }}</div>
            <div v-if="day3(date, 18) != false ">{{ 18 + day2(date, 18) }}</div>
            <div v-if="day3(date, 19) != false ">{{ 19 + day2(date, 19) }}</div>
            <div v-if="day3(date, 20) != false ">{{ 20 + day2(date, 20) }}</div>
            <div v-if="day3(date, 21) != false ">{{ 21 + day2(date, 21) }}</div>
            <div v-if="day3(date, 22) != false ">{{ 22 + day2(date, 22) }}</div>
            <div v-if="day3(date, 23) != false ">{{ 23 + day2(date, 23) }}</div>
            <div v-if="day3(date, 24) != false ">{{ 24 + day2(date, 24) }}</div>
            <div v-if="day3(date, 25) != false ">{{ 25 + day2(date, 25) }}</div>
            <div v-if="day3(date, 26) != false ">{{ 26 + day2(date, 26) }}</div>
            <div v-if="day3(date, 27) != false ">{{ 27 + day2(date, 27) }}</div>
            <div v-if="day3(date, 28) != false ">{{ 28 + day2(date, 28) }}</div>
            <div v-if="day3(date, 29) != false ">{{ 29 + day2(date, 29) }}</div>
            <div v-if="day3(date, 30) != false ">{{ 30 + day2(date, 30) }}</div>
            <div v-if="day3(date, 31) != false ">{{ 31 + day2(date, 31) }}</div> -->
    </div>

    <div
      :style="i % 2 == 1 ? { background: '#f5f5f5' } : { background: '#fff' }"
      v-for="(item, i) in items"
      :key="i"
      class="container"
      :class="{
        'custom-mt': i / 8 == 1,
        'custom-mt3': i / 52 == 1,
        'custom-mt6': i / 74 == 1,
        'custom-mt4': i / 96 == 1,
        'custom-mt5': i / 30 == 1 || i / 41 == 1,
        'custom-mt2':
          i / 19 == 1 ||
          i / 118 == 1 ||
          i / 140 == 1 ||
          i / 162 == 1 ||
          i / 184 == 1 ||
          i / 206 == 1 ||
          i / 228 == 1 ||
          i / 250 == 1 ||
          i / 272 == 1,
      }"
    >
      <div>{{ i + 1 }}</div>
      <div>{{ item.employeeName }}</div>
      <div>{{ item.jobNumber }}</div>
      <!-- <div class="c-3">{{ item.currentSituation == 4 ? 'متفرغ' : ''
                    }}</div> -->
      <div>{{ item.totalAbsents }}</div>
      <div
        v-for="(detail, id) in item.details"
        :key="id"
        :style="
          detail.dayTypeString == 'عطلة' ||
          detail.dayTypeString == 'عطلة الأسبوع'
            ? { 'background-color': '#d3d3d3' }
            : i % 2 == 1
            ? { background: '#f5f5f5' }
            : { background: '#fff' }
        "
      >
        <div v-if="detail.dayType == 3">
          <p>-</p>
          <p>إجازة</p>
        </div>
        <div v-else-if="detail.currentSituation == 4">
          <p>-</p>
          <p>متفرغ</p>
        </div>

        <div v-else-if="detail.currentSituation == 5">
          <p>-</p>
          <p>مكلف</p>
        </div>

        <div v-else-if="detail.currentSituation == 6">
          <p>-</p>
          <p>تدريب</p>
        </div>
        <div v-else-if="detail.currentSituation == 2">
          <p>-</p>
          <p>منتدب</p>
        </div>

        <div v-else-if="detail.dayTypeString == 'عطلة'">
          <p>-</p>
          <p>عطلة</p>
        </div>

        <div v-else-if="detail.excuseType == '4'">
          <p>
            {{
              detail.attendanceTime == null
                ? "-"
                : convertTime(detail.attendanceTime)
            }}
          </p>
          <p>عذر</p>
        </div>

        <div v-else-if="detail.excuseType == '3'">
          <p>-</p>
          <p>غائب بعذر</p>
        </div>

        <div v-else>
          <p>
            {{
              detail.attendanceTime == null
                ? "-"
                : convertTime(detail.attendanceTime)
            }}
          </p>
          <p>
            {{ detail.leaveTime == null ? "-" : convertTime(detail.leaveTime) }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { time } from "console";
import env from "../../../env";

export default {
  mounted() {},
  props: {
    DateTo: String,
    date: String,
    pathLogo: String,
    Department: String,
    items: [Array, Object],
    alldata: [Array, Object],
  },

  data() {
    return {
      currentSort: "",
      currentSortOrder: "asc",
      red: "#ecbbbb",
      blue: "#adc8f5",
      green: "#7ecf81",
      m: env.mTop(),
    };
  },
  methods: {
    day_n(event) {
      let d = new Date(event);
      let fullDay = d.getDate();

      return fullDay;
    },

    convertDayString(event) {
      let day;
      switch (event) {
        case "الخميس":
          day = "خ";
          break;
        case "الجمعة":
          day = "ج";
          break;
        case "السبت":
          day = "س";
          break;
        case "الأحد":
          day = "ح";
          break;
        case "الاثنين":
          day = "ن";
          break;
        case "الثلاثاء":
          day = "ث";
          break;
        case "الأربعاء":
          day = "ع";
      }

      return day;
    },

    day3(event, id) {
      try {
        let d = new Date(event);
        let fullDay = new Date(
          d.getMonth() + 1 + "/" + id + "/" + d.getFullYear()
        );
        // alert(fullDay)
        // var days = [' - Su', ' - Mo', ' - Tu', ' - We', ' - Th', ' - Fr', ' - Sa'];
        var days = ["ح", "ن", "ث", "ع", "خ", "ج", "س"];
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }

        if (
          (days[fullDay.getDay()] == "ج" && days[fullDay.getDay()] != "س") ||
          (days[fullDay.getDay()] != "ج" && days[fullDay.getDay()] == "س")
        ) {
          return false;
        }
      } catch (error) {}
    },

    day2(event, id) {
      try {
        let d = new Date(event);
        let fullDay = new Date(
          d.getMonth() + 1 + "/" + id + "/" + d.getFullYear()
        );
        // alert(fullDay)
        // var days = [' - Su', ' - Mo', ' - Tu', ' - We', ' - Th', ' - Fr', ' - Sa'];
        var days = [" - ح", " - ن", " - ث", " - ع", " - خ", " - ج", " - س"];
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return days[fullDay.getDay()];
      } catch (error) {}
    },

    convert(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return (
          d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate()

          // +
          // " , "
          // +
          // d.getHours() +
          // ":" +
          // d.getMinutes()
        );
      } catch (error) {}
    },

    convertTime(event) {
      try {
        var time = event;
        var resultArray = time.split(":");

        return time.replace(":" + resultArray[2], "");
      } catch (error) {}
    },
    convertToUi(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return (
          d.getMonth() + 1 + "-" + d.getFullYear()

          // +
          // " , "
          // +
          // d.getHours() +
          // ":" +
          // d.getMinutes()
        );
      } catch (error) {}
    },
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/TimesheetD";

.col_color {
  margin-top: 60px;
  direction: rtl;
  color: black;
  background-color: rgb(236, 187, 187);
  padding: 0px 10px 0px 10px;
  margin-left: 10px;
}

.custom-mt {
  margin-bottom: 17px;
}

.custom-mt2 {
  margin-bottom: 72px;
}

.custom-mt3 {
  margin-bottom: 58px;
}

.custom-mt4 {
  margin-bottom: 112px;
}

.custom-mt5 {
  margin-bottom: 49px;
}

.custom-mt6 {
  margin-bottom: 92px;
}

.mt-shortName {
  margin-top: 68px;
}

.pathLogo-mt {
  margin-top: 153px !important;
}
</style>